import { PackageConfiguration } from '../interfaces/PackageConfiguration';

export default class Configuration {
  private static config: PackageConfiguration = {
    apiKey: process.env.REACT_APP_LOGGING_API_KEY,
    apiHostName: process.env.REACT_APP_LOGGING_API_HOSTNAME,
    apiOrigin: `https://${window.location.hostname}/`,
    environment: process.env.REACT_APP_LOGGING_ENVIRONMENT,

    // Should come frome the app, not from the package
    applicationName: process.env.REACT_APP_LOGGING_APPLICATION_NAME,
    monitoringScope: process.env.REACT_APP_LOGGING_MONITORING_SCOPE,
    silo: process.env.REACT_APP_LOGGING_SILO,
  };

  public static Current(): PackageConfiguration { return Configuration.config; }
}
